import { PIN_VERIFICATION_TYPES } from './constant';

/**
 * @param {object} userResponse
 * @param {string} pinVerificationType
 * @param {object} currentUserData
 * @returns {object}
 */
export function keepReferralPropertyForLoginModalType(userResponse, pinVerificationType, currentUserData) {
  if (pinVerificationType === PIN_VERIFICATION_TYPES.LOGIN) {
    // if modal is not of login type then keep old first order
    userResponse.isFirstOrder = currentUserData.userData.isFirstOrder;
    userResponse.referralCode = currentUserData.userData.referralCode;
  }
  return userResponse;
}
